export default __webpack_public_path__ + "static/media/list_milita_3.dd9c393e.png";